module.exports = __webpack_public_path__ + "static/media/Icon_ChevronDown.7a5c3e5a.svg";